import React from 'react';
import { useRecordContext, FieldProps } from 'react-admin';
import { Typography } from '@mui/material';
import { useTimezone } from '../../contexts/TimezoneContext';

interface TimezoneAwareDateFieldProps extends FieldProps {
  source: string;
  showTime?: boolean;
  showDate?: boolean;
}

export const TimezoneAwareDateField: React.FC<TimezoneAwareDateFieldProps> = (props) => {
  const { source, showTime = true, showDate = true, ...rest } = props;
  const { formatDate } = useTimezone();
  const record = useRecordContext();
  
  if (!record || !record[source]) {
    return null;
  }
  
  const value = record[source];
  let format: 'date' | 'time' | 'datetime' = 'datetime';
  
  if (!showTime && showDate) {
    format = 'date';
  } else if (showTime && !showDate) {
    format = 'time';
  }
  
  const formattedDate = formatDate(value, format);
  
  return (
    <Typography variant="body2" component="span" {...rest}>
      {formattedDate}
    </Typography>
  );
};